import { render, staticRenderFns } from "./ConfigCodeDialog.html?vue&type=template&id=256d4899&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigCodeDialog.scss?vue&type=style&index=0&id=256d4899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d4899",
  null
  
)

export default component.exports